export default __webpack_public_path__ + "static/media/Solo-sin-fondo.961597d7.png";